import type {
  AssessmentConsentRecord,
  CarePathwayMetadata,
} from '../../assessment-portal/types/questionnaire';
import { CONSENT_CATEGORY_MAP, consentItems } from '../data/constants';
import { CARE_PATHWAY_CONSENT } from '../data/care-pathway-consent';
import type { AdhdFlowState } from '../types/flow';

export type { AssessmentConsentRecord, CarePathwayMetadata };

export const buildConsentMetadata = (
  flowState: AdhdFlowState,
): AssessmentConsentRecord[] => {
  const records: AssessmentConsentRecord[] = consentItems
    .filter((item) => flowState.consent[item.key])
    .map((item) => ({
      key: item.key,
      name: CONSENT_CATEGORY_MAP[item.key] || 'Consents',
      label: item.title,
      summary: item.summary,
      details: item.details,
      answer: 'Accepted' as const,
      accepted: true,
    }));

  return records;
};

export const buildCarePathwayMetadata = (
  flowState: AdhdFlowState,
): CarePathwayMetadata => ({
  accepted: flowState.carePathway.isAccepted,
  summary: CARE_PATHWAY_CONSENT.summary,
  acceptanceStatement: CARE_PATHWAY_CONSENT.acceptanceStatement,
});
